import apiConfig from "@/config/api-config";
import axiosConfig from "@/services/v1/axios.service";

export const refreshToken = async (role) => {
  
  try {
    let res;
    if (role === "PLACEMENT_OFFICER") {
      res = await axiosConfig.get(`${apiConfig.AUTH_API_ROOT_PO}/refresh-token`);
    } else if (role === "STUDENT") {
      res = await axiosConfig.get(`${apiConfig.AUTH_API_ROOT_STUDENT}/refresh-token`);
    } else if (role === "HUMAN_RESOURCE") {
      res = await axiosConfig.get(`${apiConfig.AUTH_API_ROOT_HR}/refresh-token`);
    }
    return res?.data?.accessToken || null;
  } catch (error) {
    console.error("Failed to refresh token", error);
  }
};
